import { useLocation, useNavigate } from 'react-router-dom';

const useQueryParams = () => {
  const { search } = useLocation();
  const navigate = useNavigate();

  const params = new URLSearchParams(search);

  const allParams = Object.fromEntries(params.entries());

  const getParam = (key) => params.get(key);

  const setParam = (key, value) => {
    if (value === null || value === undefined || value === '') {
      params.delete(key);
    } else {
      params.set(key, value);
    }
    navigate({ search: params.toString() }, { replace: true });
  };

  const setParams = (newParamsObj) => {
  if (!newParamsObj || Object.keys(newParamsObj).length === 0) {
    navigate({ search: "" }, { replace: true });
    return;
  }

  const newSearchParams = new URLSearchParams(search);

  Object.entries(newParamsObj).forEach(([key, value]) => {
    if (value === null || value === undefined || value === "") {
      newSearchParams.delete(key);
    } else {
      newSearchParams.set(key, value);
    }
  });

  navigate({ search: newSearchParams.toString() }, { replace: true });
};

  const deleteParam = (key) => {
    params.delete(key);
    navigate({ search: params.toString() }, { replace: true });
  };

  const setOnlyParam = (key, value) => {
  const newSearchParams = new URLSearchParams();
  if (value !== null && value !== undefined && value !== "") {
    newSearchParams.set(key, value);
  }
  navigate({ search: newSearchParams.toString() }, { replace: true });
};
  return { allParams, getParam, setParam, setParams,setOnlyParam, deleteParam };
};

export default useQueryParams;